export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_job_position/create', params)
	},
	update (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_job_position/update', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_job_position/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_job_position/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/ShopJobPosition.js